import UniMachineModalElement from "../element";
import { CustomEventObject, TEvent } from "../types/types";
import { listCode } from "./toasts/error-list-code";

const machineElement = new UniMachineModalElement();

export async function service<TContext, EventType extends CustomEventObject>(
  ctx: TContext,
  e: TEvent<EventType>,
  config: { services: any; index: number }
) {
  const { services, index } = config;
  machineElement.Loading(true);
  const serviceValue = Object.values(services)[index];

  return await (serviceValue as any)(ctx, e)
    .then((res: { message: any; mode: any }) => {
      machineElement.Loading(false);
      if (res?.message) {
        const mode = res.mode ? false : true;
        machineElement.Notification({
          show: mode,
          message: res.message,
          type: "toast-success",
          shortText: "notification",
        });
      }
      return res;
    })
    .catch((err: { code: number; message: any }) => {
      machineElement.Loading(false);
      const index = listCode.findIndex((item) => item.code == err.code);
      if (index != -1) {
        machineElement.ModalConfirm({
          show: true,
          message: listCode[index].message
            ? listCode[index].message
            : err.message,
        });
      } else {
        if (err && err.message) {
          machineElement.Notification({
            show: true,
            message: err.message,
            type: "toast-error",
            shortText: "notification",
          });
        }
      }
      return Promise.reject(err);
    });
}
